export default "__VITE_ASSET__0bd3ae4e__"